var React = require('react');

function Jp (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"#fff","height":"600","width":"900","key":0}),React.createElement("circle",{"fill":"#bc002d","cx":"450","cy":"300","r":"180","key":1})]);
}

Jp.defaultProps = {"viewBox":"0 0 900 600"};

module.exports = Jp;

Jp.default = Jp;
